import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import { DefaultPermissionsState, PermissionsState } from "../state/stateItems";
import { TPermissionItem } from "@/data/types";
import { getAllPermissionsAsync, getPermissionByIdAsync } from "../actions";

const handleGetAllPermissionsAsync = (
  state: PermissionsState,
  action: PayloadAction<{ items: TPermissionItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.items = items;
};

const handleGetPermissionByIdAsync = (
  state: PermissionsState,
  action: PayloadAction<TPermissionItem>
) => {
  if (!action?.payload) {
    return state;
  }

  const permission = action.payload;

  state.currentPermission = permission;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<PermissionsState>) => {
  builder.addCase(getAllPermissionsAsync.fulfilled.type, handleGetAllPermissionsAsync);
  builder.addCase(getPermissionByIdAsync.fulfilled.type, handleGetPermissionByIdAsync);
};

export default createReducer(DefaultPermissionsState, reducerBuilder);